'use client';

import { ElementType, useState } from 'react';

import { Spacer, SpacerSize, Title, TitleLevels, TitleMarkup } from '@bytel/trilogy-react';

import { SSIBlock } from '@components/ssi-block';

import { classNames } from '@helpers/classnames';

const faqStyles = `
    .faq-container.show-limited details:nth-child(n + 6) {
        display: none;
    }
`;

export function Faq({ isMobilePlan }: Readonly<{ isMobilePlan: boolean }>) {
    const [canShowMore, setCanShowMore] = useState(false);

    return (
        <>
            <style>{faqStyles}</style>
            <Title className='has-text-centered' markup={TitleMarkup.H2} level={TitleLevels.TWO}>
                Vos questions fréquentes <br />
                sur {isMobilePlan ? ' les forfaits B&YOU' : 'nos box internet sans engagement'}
            </Title>
            <SSIBlock<ElementType>
                url={isMobilePlan ? '/partials/faq/emplacements/byou-pwa' : '/partials/faq/emplacements/byou-fai'}
                containerProps={{
                    className: classNames(canShowMore ? '' : ' show-limited', 'faq-container'),
                }}
            />
            <Spacer size={SpacerSize.FOUR} />
            <div className='has-text-centered'>
                <button className='button-clear link' onClick={() => setCanShowMore(!canShowMore)}>
                    {canShowMore ? 'Moins de questions' : 'Voir les autres questions'}
                </button>
                <Spacer size={SpacerSize.ZERO} />
            </div>
        </>
    );
}
